import { useEffect } from 'react';

export function useIframeHeight() {
  useEffect(() => {
    const sendHeight = () => {
      const height = document.body.scrollHeight;
      window.parent.postMessage(height, '*');
    };

    window.onload = sendHeight;
    window.onresize = sendHeight;

    const observer = new MutationObserver(sendHeight);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    return () => {
      observer.disconnect();
    };
  }, []);
}
